const fr = {
  apply: {
    congrat_1_steps: "1. Scannez le QR code depuis l'appareil photo de votre Smartphone",
    congrat_2_steps: "2. Téléchargez l'application et finalisez votre profil",
    congrat_3_steps: '3. Accédez à votre candidature et aux centaines de missions près de chez vous',
    download_app: 'Télécharger',
    form_address_label: 'Adresse',
    form_address_placeholder: '21 rue de Châteaudun 75008, Paris',
    form_email_label: 'Email',
    form_email_placeholder: 'johndoe@iziwork.com',
    form_email_placeholder_pm: 'johndoe@interim.proman-solutions.fr',
    form_firstname_label: 'Prénom',
    form_firstname_placeholder: 'John',
    form_lastname_label: 'Nom',
    form_lastname_placeholder: 'Doe',
    form_phone_label: 'Téléphone',
    form_phone_placeholder: '06 63 63 63 63',
    form_resume_button: 'Importer',
    form_resume_label: 'CV',
    form_resume_label_pstf: 'CV',
    message_info_accept_conditions: 'ainsi que la',
    message_info_accept_tcu: 'En continuant, vous acceptez les',
    modal_action_apply: 'Postuler',
    modal_action_close: 'Fermer',
    step_unknown: {
      dropzone: {
        drop: 'Glissez déposez ou ',
        select: 'sélectionnez votre fichier',
        supported_files: 'Fichiers supportés : IMAGES, PDF, DOC, DOCX',
      },
    },
    subtitle_download_app: 'Téléchargez notre application pour suivre votre candidature.',
    subtitle_email_to_identify: "Votre email nous permet d'identifier si nous nous connaissons déjà.",
    subtitle_resume_to_apply: 'Nous avons besoin de votre CV et de vos coordonnés pour traiter votre candidature.',
    subtitle_resume_to_apply_pstf: 'Nous avons besoin de votre CV et de vos coordonnés pour traiter votre candidature.',
    tcu_conditions: 'Politique de Confidentialité',
    tcu_confidentiality: "Conditions Générales d'Utilisation",
    title_congratulation: 'Bravo, votre candidature a bien été envoyée !',
    title_free_apply: 'Postuler pour une mission',
    title_job_offer_apply: 'Postuler pour cette mission',
    title_you_are_new: 'Nous ne nous connaissons pas encore !',
  },
  banner: {
    join_community: 'Rejoignez la communauté <span>{{name}}</span>',
    large_choice: 'Large choix de missions',
    large_choice_desc:
      'J’ai accès à un large choix de missions en intérim, CDD, CDI dans ma région, sur tous les métiers qui m’intéressent.',
    personal_service: 'Suivi personnalisé & valorisé',
    personal_service_desc:
      'Mon chargé de recrutement dédié m’accompagne au jour le jour. Plus je travaille avec iziwork, plus je bénéficie d’avantages !',
    personal_service_desc_pm:
      'Mon chargé de recrutement dédié m’accompagne au jour le jour. Plus je travaille avec Proman Solutions, plus je bénéficie d’avantages !',
    simple_and_fast: 'Simple & rapide',
    simple_and_fast_desc:
      "Plus de déplacements en agence : je choisis ma mission en 3 clics, j'ajoute simplement mes documents.",
  },
  breadcrumbs: {
    home: 'Accueil',
  },
  buttons: {
    contact_us: 'Nous contacter',
    load_more: 'Voir plus',
  },
  cities_page: {
    meta_description:
      "Trouvez nos offres d'emploi en intérim, CDI et CDD dans votre ville et postulez en quelques clics.",
    meta_title: "Nos offres d'emploi par ville - iziwork",
    title: 'Toutes les villes',
  },
  city_job_page: {
    heading: 'Travailler comme {{job}} à {{city}}',
    latest_job_offers: 'Nos dernières offres de {{job}} à {{city}}',
    meta_description:
      "Retrouvez nos offres d'emploi en intérim, CDI et CDD pour le métier de {{job}} à {{city}} et postulez en quelques clics",
    meta_title: "Nos offres d'emploi de {{job}} à {{city}} - iziwork",
    title: 'Nos offres de <span>{{job}}</span> à <span>{{city}}</span>',
  },
  city_page: {
    heading: 'Travailler à {{city}}',
    latest_job_offers: 'Nos dernières offres à {{city}}',
    meta_description:
      "Offres d'emploi en intérim, CDI et CDD à {{city}} : préparateur de commandes, cariste, manutentionnaire… Postulez en 3 clics avec iziwork.",
    meta_title: "Nos offres d'emploi à {{city}} - iziwork",
    title: 'Nos offres à <span>{{city}}</span>',
  },
  consent_manager: {
    content:
      'Nous utilisons l’information collectée par des cookies et des librairies JavaScript pour améliorer votre expérience de navigation, analyser le trafic sur notre site, afficher des publicités personnalisées et augmenter la performance de notre site.',
    title: 'Gérer mes préférences',
  },
  date: {
    today: "aujourd'hui",
  },
  error_pages: {
    internal_server_error_title: "Oops, une erreur s'est produite...",
    not_found_subtitle1: 'Mais ne vous inquiétez pas, nos développeurs la recherchent !',
    not_found_subtitle2: "Jusqu'à ce qu'ils trouvent, vous pouvez revenir à l'accueil.",
    not_found_title: 'Oups, il semble que la page que vous regardiez a disparu.',
    redirect_label: "Revenir à l'accueil",
  },
  expired_job_offer: {
    meta_title: 'Offre expirée : {{title}} à {{city}}',
    meta_title_without_city: 'Offre expirée : {{title}}',
    subtitle: "L'offre {{title}} à {{city}} a été pourvue ou retirée. Découvrez d'autres offres près de chez vous.",
    subtitle_without_city: "L'offre {{title}} a été pourvue ou retirée. Découvrez d'autres offres près de chez vous.",
    title: "Cette offre n'est plus disponible",
  },
  field_errors: {
    address_valueIncomplete: "L'adresse est incomplète",
    address_valueMissing: "L'adresse est obligatoire",
    captcha_valueMissing: 'Le champ est obligatoire',
    email_typeMismatch: "L'email est incorrect",
    email_valueMissing: "L'email est obligatoire",
    firstname_valueMissing: 'Le prénom est obligatoire',
    lastname_valueMissing: 'Le nom est obligatoire',
    phone_typeMismatch: 'Le téléphone est incorrect',
    phone_valueMissing: 'Le téléphone est obligatoire',
    resume_invalidSize: 'La taille du fichier doit être comprise entre 1Ko et 10Mo',
    resume_invalidType: 'Le type de fichier est invalide',
    resume_valueMissing: 'Le CV est obligatoire',
    resume_valueMissing_pstf: 'Le CV est obligatoire',
  },
  footer: {
    aboutUs: 'À propos de nous',
    account: 'Se connecter',
    askADemo: 'Demander une démo',
    blog: 'Blog',
    companies: 'Entreprises',
    companySpace: 'Espace entreprises',
    confidentiality: 'Politique de confidentialité',
    cookies_policy: 'Politique de cookies',
    cookies_settings: 'Paramètres de cookies',
    join: 'Nous rejoindre',
    legal_mentions: 'Mentions légales',
    partners: 'Partners',
    personalData: 'Données personnelles',
    press: 'Espace Presse',
    program: 'Programme Partners',
    rgpd: 'Vos droits RGPD',
    sitemap: 'Plan du site',
    socialMedia: {
      facebook: 'Nous suivre sur Facebook',
      instagram: 'Voir nos stories Instagram',
      linkedin: 'Nous ajouter sur LinkedIn',
      twitter: 'Voir nos stories Twitter',
    },
    usage_conditions: "Conditions d'utilisation",
    usage_conditions_pm: 'CGU',
    who: 'Qui sommes-nous ?',
    why: 'Pourquoi Iziwork ?',
    worker: 'Intérimaires',
  },
  form_errors: {
    address: 'Veuillez sélectionner une ville',
    job: 'Veuillez entrer un métier',
  },
  form_labels: {
    address: 'Ville',
    address_pstf: 'Ville',
    distance: '< {{distance}} km',
    experience: 'Expérience requise',
    job: 'Métier',
    sort: 'Trier par',
    type: 'Type de contrat',
  },
  form_option_labels: {
    experience: {
      all: 'Toutes',
      any: 'Première expérience requise',
      five_years: 'Plus de 5 ans',
      none: 'Pas d’expérience requise',
      one_month: 'Au moins 1 mois',
      one_year: 'Au moins 1 an',
      six_months: 'Au moins 6 mois',
      three_months: 'Au moins 3 mois',
      two_years: 'Entre 2 ans et 5 ans',
    },
    sort: {
      publication: 'Date de publication',
      relevance: 'Pertinence',
    },
    type: {
      all: 'Tous',
      contract: 'CDD',
      non_seasonal_temporary: 'Intérim',
      permanent: 'CDI',
      permanent_pstf: 'Embauche directe',
      seasonal_temporary: 'Intérim',
      temporary: 'Intérim',
      temporary_pstf: 'Temp',
    },
    urgent: 'Urgente',
  },
  form_option_values: {
    experience: {
      any: 'premiere',
      five_years: '5 ans et plus',
      none: 'aucune',
      one_month: '1 mois',
      one_year: '1 an',
      six_months: '6 mois',
      three_months: '3 mois',
      two_years: '2 ans et plus',
    },
    sort: {
      publication: 'publication',
      relevance: 'pertinence',
    },
    type: {
      contract: 'cdd',
      non_seasonal_temporary: 'interim non saisonnier',
      permanent: 'cdi',
      seasonal_temporary: 'intérim saisonnier',
      temporary: 'interim',
    },
  },
  form_placeholders: {
    address: 'Rechercher une ville',
    address_pstf: 'Rechercher une ville',
    job: 'Rechercher un métier',
    type: 'Rechercher un type de contrat',
  },
  form_title: 'Votre recherche pour',
  free_application_card: {
    button: "C'est parti",
    message: 'Envoyez votre CV et nous vous contacterons dès que nous aurons trouvé une offre pour vous.',
    title: 'Vous cherchez un emploi ?',
  },
  header: {
    findMission: 'Trouver un job',
    myApply: 'Mes Applications',
    partners: 'Avis sur les entreprises',
  },
  home_page_offers: {
    buttons: {
      cities: 'Découvrir toutes les villes',
      sectors: 'Découvrir tous les domaines',
    },
    title_1: '<span>{{formattedCount}}</span> offre à pourvoir partout en France',
    title_other: '<span>{{formattedCount}}</span> offres à pourvoir partout en France',
  },
  job_page: {
    heading: 'Travailler comme {{job}}',
    latest_job_offers: 'Nos dernières offres de {{job}}',
    meta_description:
      "Retrouvez nos offres d'emploi en intérim, CDI et CDD pour le métier de {{job}} et postulez en quelques clics",
    meta_title: "Nos offres d'emploi de {{job}} - iziwork",
    title: 'Nos offres de <span>{{job}}</span>',
  },
  jobs_page: {
    meta_description:
      "Préparateur de commandes, cariste, agent de production… Trouvez nos offres d'emploi en intérim, CDI et CDD par métier et postulez en quelques clics.",
    meta_title: "Nos offres d'emploi par métier - iziwork",
    title: 'Tous les métiers',
  },
  latest_job_offers: {
    page: 'Page {{page}}',
    title: 'Nos dernières offres',
  },
  list_grid_layout: {
    cities: {
      title: 'Nos offres par villes',
    },
    jobs: {
      title: 'Nos offres par métiers',
    },
    sectors: {
      title: 'Nos offres par domaines',
    },
  },
  menu: {
    b2b_button: 'Je suis une entreprise',
    cities: 'Villes',
    entreprise_button_mobile: 'Entreprise',
    jobs: 'Métiers',
    link: {
      cities: 'Voir toutes les villes',
      jobs: 'Voir tous les métiers',
      sectors: 'Voir tous les secteurs',
    },
    sectors: "Secteurs d'activité",
  },
  meta_description: {
    jobOffer: {
      default: 'Consultez notre mission de {{title}} à {{city}}.',
      suffix: 'Candidatez en 3 clics maintenant, travaillez demain !',
      type: {
        contract: 'Consultez notre mission en CDD de {{title}} à {{city}}.',
        permanent: 'Consultez notre mission en CDI de {{title}} à {{city}}.',
        temporary: 'Consultez notre mission en intérim de {{title}} à {{city}}.',
      },
    },
  },
  meta_social_description: {
    mission_description:
      'Découvrez notre mission de {{displayName}} près de {{city}}. Candidatez en 3 clics maintenant, travaillez demain !',
    mission_title: "{{displayName}} - {{city}} ({{areaCode}}) - Offre d'emploi",
    partner_description: 'Des dizaines de postes à pourvoir près de {{city}} ! Candidature facile et rapide.',
    partner_title: "Nos offres d'emploi près de {{city}} ({{areaCode}})",
  },
  missions: {
    about: 'À propos de la mission',
    apply: 'Postuler',
    back: 'Revenir à la recherche',
    bonuses: 'Avantages',
    certificates: 'Certificats',
    close_distance: 'proche',
    contractType: 'Type de contrat',
    details_tab_label: 'Détails',
    distance: 'à {{distance}} km',
    experience: 'Expérience',
    informations: 'Informations',
    location: 'Lieu',
    mission_h1: {
      with_area: '{{title}} à {{city}} ({{areaCode}})',
      without_area: '{{title}} à {{city}}',
    },
    mission_title: {
      with_area: "{{title}} à {{city}} ({{areaCode}}) - Offre d'emploi",
      without_area: "{{title}} à {{city}} - Offre d'emploi",
    },
    no_certificates_required: 'Aucun certificat requis',
    no_experience_required: "Pas d'expérience requise - jeunes, travailleurs sans qualifications... bienvenus",
    no_experience_required_pstf: "Pas d'expérience requise - jeunes, travailleurs sans qualifications... bienvenus",
    profile: 'Profil recherché',
    published: 'Parue ',
    remuneration: 'Rémunération',
    see_all_missions: 'Voir toutes ses missions',
    see_all_offers: 'Voir toutes les offres',
    weekly_hours: {
      default: '{{hours}} heures / semaine',
      hours: '{{hours}} heures',
      per_week: 'par semaine',
    },
    workTime: 'Temps de travail',
  },
  no_mission_modal: {
    button: {
      close: 'Fermer',
      next: 'Suivant',
    },
    download_app: 'Téléchargez l’application iziwork dès maintenant !',
    download_app_pm: 'Téléchargez l’application Proman Solutions dès maintenant !',
    download_app_subtitle: "Inscrivez-vous et complétez votre profil en 5mn grâce à notre système d'analyse de CV.",
    download_app_subtitle_pstf:
      "Inscrivez-vous et complétez votre profil en 5mn grâce à notre système d'analyse de CV.",
    placeholder: {
      email: 'Votre adresse email',
      phone: 'Votre numéro de téléphone',
    },
    step: 'Étape {{step}} / 2',
    subtitle:
      'Nous cherchons sans cesse les meilleures opportunités pour vous ! Renseignez vos informations, et nous vous informerons dès que nous aurons des missions à vous proposer :',
    success: {
      body: "Inscrivez-vous et complétez votre profil en 5mn grâce a notre système d'analyse de CV.",
      body_pstf: "Inscrivez-vous et complétez votre profil en 5mn grâce a notre système d'analyse de CV.",
      subtitle: 'Vous y êtes presque !',
      title: 'Découvrez nos missions dans notre application',
    },
    title: 'Oups, il semble qu’aucune offre n’ait été trouvée !',
  },
  no_missions_result: {
    download_app: 'Téléchargez l’application iziwork dès maintenant !',
    download_app_pm: 'Téléchargez l’application Proman Solutions dès maintenant !',
    download_hint:
      'Téléchargez l’application et nous vous informerons dès que nous aurons des missions à vous proposer.',
    subtitle: 'Nous cherchons sans cesse les meilleures opportunités pour vous !',
    title: 'Oups, il semble qu’aucune offre n’ait été trouvée !',
  },
  pain_points_page: {
    meta_description:
      "Recrutement, métiers en tension, conformité, gestion administrative, fidélisation : les réponses d'iziwork aux enjeux de l'intérim pour les entreprises.",
    meta_title: 'Vos enjeux de recrutement en intérim - iziwork',
    title: 'Problématiques',
  },
  salary: {
    gross_per_unit: {
      hourly: 'Brut/heure',
      hourly_pstf: 'Brut/heure',
      monthly: 'Brut/mois',
      monthly_pstf: 'Brut/mois',
      yearly: 'Brut/an',
      yearly_pstf: 'Brut/an',
    },
  },
  search_button: {
    label: 'Rechercher',
  },
  search_params: {
    address: 'ville',
    distance: 'distance',
    experience: 'experience',
    job: 'metier',
    page: 'page',
    sort: 'tri',
    type: 'contrat',
  },
  sector_page: {
    heading: 'Travailler en {{sector}}',
    latest_job_offers: 'Nos dernières offres en {{sector}}',
    meta_description:
      "{{sector}} : retrouvez nos offres d'emploi en intérim, CDI, ou CDD dans votre ville. Postulez en ligne ou sur notre appli en quelques instants.",
    meta_title: "Secteur {{sector}} : offres d'emploi en intérim - iziwork",
    title: 'Nos offres en <span>{{sector}}</span>',
  },
  sectors_page: {
    meta_description:
      "Logistique, industrie, hôtellerie-restauration… Trouvez nos offres d'emploi en intérim, CDI et CDD par secteur d'activité et postulez en quelques clics.",
    meta_title: "Nos offres d'emploi par secteur - iziwork",
    title: "Tous les secteurs d'activité",
  },
  similar_offers: {
    title_nearby: "D'autres offres près de {{city}}",
    title_with_location: "D'autres offres de {{title}} à {{city}}",
    title_without_city: "D'autres offres à proximité",
  },
  sitemap_page: {
    meta_description:
      "Plan du site iziwork : toutes nos offres d'emploi en intérim, CDI et CDD, nos pages par ville, par métier et par secteur d'activité.",
    meta_title: 'Plan du site - iziwork',
    title: 'Plan du site',
  },
  solutions_page: {
    meta_description:
      'Onsite, central staffing, matching automatique : les solutions iziwork pour recruter et gérer vos intérimaires sur tous vos sites.',
    meta_title: 'Nos solutions de recrutement en intérim pour les entreprises - iziwork',
    title: 'Solutions',
  },
  tags: {
    experience: {
      any: 'Première expérience requise',
      five_years: "Plus de 5 ans d'expérience",
      none: 'Pas d’expérience requise',
      one_month: "Au moins 1 mois d'expérience",
      one_year: "Au moins 1 an d'expérience",
      six_months: "Au moins 6 mois d'expérience",
      three_months: "Au moins 3 mois d'expérience",
      two_years: "Entre 2 ans et 5 ans d'expérience",
    },
  },
  title: {
    '404_error': "Page introuvable - Offres d'emploi iziwork",
    '404_error_pm': "Page introuvable - Offres d'emploi Proman Solutions",
    '404_error_pstf': "Page introuvable - Offres d'emploi Proman Staffing",
    '500_error': "Erreur inconnue - Offres d'emploi iziwork",
    '500_error_pm': "Erreur inconnue - Offres d'emploi Proman Solutions",
    '500_error_pstf': "Erreur inconnue - Offres d'emploi Proman Staffing",
  },
  toasts: {
    application_error_body: "Votre candidature n'a pas été prise en compte, veuillez réessayer ultérieurement.",
    application_error_title: 'Une erreur est survenue',
    install_app_sms_error_body: "Votre demande n'a pas été prise en compte, veuillez réessayer ultérieurement.",
  },
  url: {
    askADemo: 'recrutement-interim',
    blog: 'actus',
    companySpace: 'entreprises',
    confidentiality: 'politique-de-confidentialite',
    cookie: 'politique-des-cookies',
    legalMentions: 'mentions-legales',
    partners: 'pourquoi-devenir-partner',
    personalData: 'formulaire-exercice-droits',
    press: 'presse',
    usageConditions: 'conditions-generales-dutilisation',
    usageConditions_pstf: 'conditions-generales-dutilisation',
    who: 'a-propos',
    why: 'pourquoi-iziwork',
  },
  welcome: 'Bienvenue',
  welcome_page: {
    meta_description:
      "Offres d'emploi en intérim, CDD et CDI avec iziwork, l'agence d'intérim digitale #1 : trouvez une mission près de chez vous et postulez en 3 clics.",
    meta_description_pm:
      "Les offres d'emploi en intérim, CDD et CDI de Proman Solutions. Trouvez une mission près de chez vous et candidatez en ligne en quelques clics.",
    meta_description_pstf:
      "Des milliers d'offres d'emploi en intérim, CDD et CDI avec Proman Staffing. Trouvez une mission près de chez vous et postulez en ligne en 3 clics.",
    meta_description_search_city:
      "Offres d'emploi en intérim, CDD et CDI autour de {{city}} : trouvez une mission près de chez vous et postulez en quelques clics.",
    meta_description_search_job:
      "{{job}} : offres d'emploi en intérim, CDD et CDI. Trouvez une mission près de chez vous et postulez en quelques clics.",
    meta_description_search_job_city:
      "{{job}} : offres d'emploi en intérim, CDD et CDI autour de {{city}}. Postulez en quelques clics.",
    meta_social_description: 'Des postes à pourvoir près de chez vous ! Candidature facile et rapide.',
    meta_social_description_city: 'Des postes à pourvoir près de {{city}} ! Candidature facile et rapide.',
    meta_social_title: 'Accédez à nos offres d’emploi autour de chez vous',
    meta_social_title_city: "Nos offres d'emploi près de {{city}}",
    meta_social_title_city_zipcode: "Nos offres d'emploi près de {{city}} ({{zipcode}})",
    meta_title: "Offres d'emploi en intérim, CDD et CDI - iziwork",
    meta_title_city: '{{city}} - Nos offres d’emploi - iziwork',
    meta_title_city_pm: '{{city}} - Nos offres d’emploi - Proman Solutions',
    meta_title_city_pstf: '{{city}} - Nos offres d’emploi - Proman Staffing',
    meta_title_city_zipcode: '{{city}} ({{zipcode}}) - Nos offres d’emploi - iziwork',
    meta_title_city_zipcode_pm: '{{city}} ({{zipcode}}) - Nos offres d’emploi - Proman Solutions',
    meta_title_city_zipcode_pstf: '{{city}} ({{zipcode}}) - Nos offres d’emploi - Proman Staffing',
    meta_title_pm: "Offres d'emploi en intérim, CDD et CDI - Proman Solutions",
    meta_title_pstf: "Offres d'emploi près de chez vous - Proman Staffing",
    missions_available_0: 'Aucune offre disponible',
    missions_available_1: '1 offre d’emploi trouvée',
    missions_available_other: '{{count}} offres d’emploi trouvées',
    title: 'Nos offres<br>près de <span>chez vous !</span>',
  },
};
export default fr;
